<script setup lang="ts">
import { useScreen } from '@/composables/useScreen'
import { useStaticAsset } from '@/composables/useStaticAsset'

const asset = useStaticAsset()

interface BannerProps {
  hideMonkey?: boolean
}

defineProps<BannerProps>()

defineEmits<{
  open: []
}>()

const { isMobile } = useScreen()
</script>

<template>
  <article class="v-bitrix-form-banner">
    <img
      :src="asset('img/contact-form-banner/blob-left.svg')"
      class="v-bitrix-form-banner__blob v-bitrix-form-banner__blob_left"
    />
    <img
      :src="asset('img/contact-form-banner/blob-right.svg')"
      class="v-bitrix-form-banner__blob v-bitrix-form-banner__blob_right"
    />

    <div class="v-bitrix-form-banner__content">
      <img
        v-if="!hideMonkey && !isMobile"
        :src="asset('img/contact-form-banner/monkey.webp')"
        class="v-bitrix-form-banner__monkey"
      />

      <div class="v-bitrix-form-banner__body">
        <h3 class="text-title-bold mb-2">Если у Вас остались вопросы — <br v-if="!hideMonkey" />мы поможем</h3>
        <p class="mb-1">
          Хотите больше узнать об обучении на нашей платформе для Вас или для ваших детей, или возникли другие вопросы?
        </p>
        <p>Оставьте заявку — и мы с вами свяжемся</p>
      </div>

      <div class="v-bitrix-form-banner__actions">
        <v-button mode="primary filled large" @click="() => $emit('open')"> Свяжитесь со мной </v-button>
      </div>
    </div>
  </article>
</template>

<style lang="scss">
.v-bitrix-form-banner {
  background: #f2f8fe;
  border-radius: 16px;
  overflow: hidden;

  @include desktop {
    height: 224px;
  }

  & > * + * {
    margin-top: 0;
  }

  position: relative;

  &__blob {
    position: absolute;

    &_left {
      top: 0;
      left: 0;
      height: 100%;
    }
    &_right {
      bottom: 0;
      right: 0;
    }

    @include mobile {
      &_left {
        left: -70%;
      }
      &_right {
        right: -20%;
      }
    }
  }

  &__content {
    position: relative;
    z-index: 1;
    display: grid;
    height: 100%;

    @include desktop {
      grid-template-columns: auto minmax(auto, 490px) 1fr;
    }

    @include mobile {
      gap: 16px;
      padding: 16px;
    }
  }

  &__monkey {
    height: 224px;
  }

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;

    &:first-child {
      margin-left: 40px;
    }
  }

  &__actions {
    display: flex;

    @include desktop {
      justify-content: flex-end;
      align-items: center;
      margin-right: 40px;
    }

    @include mobile {
      flex-direction: column;
    }
  }
}
</style>
